import commonPasswordList from 'fxa-common-password-list';
import { lowerCaseCheck, digitCheck, upperCaseCheck } from '../regex';
import { ConfigService } from '@apps/firsthomecoach/src/services/config-service';

type Validator = {
  value: boolean;
  text: string;
};

type IsValidated = {
  validators: Validator[];
  isValid: boolean;
};

export const isValidated = (password: string): IsValidated => {
  const {
    lengthLabel = '10+ characters',
    lowerCaseLabel = '1+ lowercase',
    upperCaseLabel = '1+ uppercase',
    digitLabel = '1+ number',
    commonPasswordLabel = 'Uncommon password'
  } = ConfigService.get('ACCOUNT.VALIDATIONS.messages', {});
  const lengthValidation = password.length >= 10;

  const validators = [
    { value: lengthValidation, text: lengthLabel },
    { value: lowerCaseCheck.test(password), text: lowerCaseLabel },
    { value: upperCaseCheck.test(password), text: upperCaseLabel },
    { value: digitCheck.test(password), text: digitLabel },
    { value: lengthValidation && !commonPasswordList.test(password?.toLowerCase()), text: commonPasswordLabel }
  ];

  return {
    validators,
    isValid: validators.every(({ value }) => value)
  };
};
